import { secureRequest, securePostRequest } from '../utils/request';

export const getIncidentsTypes = () => secureRequest(`/api/v1/adas/incidents-types`);

export const getQuantityDynamicsIncidentsGraph = (body: any) =>
  securePostRequest(`/api/v1/adas/quantity-and-dynamics-incidents-graph`)(body).then((res) => {
    return res;
  });

export const getQuantityDynamicsIncidentsPieChart = (body: any) =>
  securePostRequest(`/api/v1/adas/quantity-and-dynamics-incidents-pie-chart`)(body).then((res) => {
    return res;
  });

export const getVehicleList = (body: any) =>
  securePostRequest(`/api/v1/adas/vehicle-list`)(body).then((res) => {
    return res;
  });

export const getVehicleOnRouteList= (body: any) =>
  securePostRequest(`/api/v1/adas/vehicle-on-route-list`)(body).then((res) => {
    return res;
  });

export const getQuantityDynamicsIncidentsTable = (body: any) =>
  securePostRequest(`/api/v1/adas/quantity-and-dynamics-incidents-table`)(body).then((res) => {
    return res;
  });

export const getQuantityDynamicsIncidentsReport = (body: any) =>
  securePostRequest(`/api/v1/adas/quantity-and-dynamics-incidents-report`)(body).then((res) => {
    return res;
  });

export const getVehicleIncidentsDetailTable = (body: any) =>
  securePostRequest(`/api/v1/adas/vehicle-incidents-detail-table`)(body).then((res) => {
    return res;
  });

export const getIncidentsRouteDistributionBarGraph = (body: any) =>
  securePostRequest(`/api/v1/adas/incidents-route-distribution-bar-graph`)(body).then((res) => {
    return res;
  });

export const getIncidentsRouteDistributionPieChart = (body: any) =>
  securePostRequest(`/api/v1/adas/incidents-route-distribution-pie-chart`)(body).then((res) => {
    return res;
  });

export const getIncidentsRouteDistributionTable = (body: any) =>
  securePostRequest(`/api/v1/adas/incidents-route-distribution-table`)(body).then((res) => {
    return res;
  });

export const getIncidentsRouteDistributionReport = (body: any) =>
  securePostRequest(`/api/v1/adas/incidents-route-distribution-report`)(body).then((res) => {
    return res;
  });

export const getIncidentsJournal = (body: any) =>
  securePostRequest(`/api/v1/adas/incidents-journal`)(body).then((res) => {
    return res;
  });
